import {theme} from "../../themes/theme";
import Box from "@mui/material/Box/Box";
interface IDetailBodyResume{
    type:"orden"|"la compra",
    resume: string
}
export const CustomDetailBodyResume = ({type, resume}:IDetailBodyResume) => {
    return (
        <Box>
            <span style={{fontWeight:theme.typography.fontWeightRegular}}>Resumen de {type}:
            </span>   {resume}
        </Box>
    );
};